import { render, staticRenderFns } from "./AdressList.vue?vue&type=template&id=9633f136&"
import script from "./AdressList.vue?vue&type=script&lang=js&"
export * from "./AdressList.vue?vue&type=script&lang=js&"
import style0 from "./AdressList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports